// extracted by mini-css-extract-plugin
export var chip = "_4w-9";
export var chipLabel = "_4w-a";
export var close = "_4w-7";
export var closeIcon = "_4w-8";
export var error = "_4w-6";
export var infoTooltip = "_4w-2";
export var innerContainer = "_4w-1";
export var input = "_4w-b";
export var medium = "_4w-5";
export var outerContainer = "_4w-0";
export var small = "_4w-4";
export var xSmall = "_4w-3";